<div class="motion-container" role="status" aria-label="loading">
    <!-- Motion 1 -->
    <div class="motion-1">
        <svg fill="none" preserveAspectRatio="none" viewBox="0 0 13 29">
            <g>
                <path
                    class="motion-path-1"
                    d="M0 14.2157C0 21.5985 5.37484 27.6733 12.2735 28.4352V22.7433C8.49949 22.0039 5.62999 18.4626 5.62999 14.2176C5.62999 9.9726 8.49949 6.4313 12.2735 5.69189V0C5.37484 0.760049 0 6.83481 0 14.2176V14.2157Z"
                />
            </g>
        </svg>
    </div>

    <!-- Motion 2 -->
    <div class="motion-2">
        <svg fill="none" preserveAspectRatio="none" viewBox="0 0 18 29">
            <g>
                <path
                    class="motion-path-2"
                    d="M17.6782 4.72918V0H8.89546V5.14016C6.55339 2.22007 3.54127 0.472908 0 0.0825622V5.7745C3.77397 6.51391 6.64346 10.0552 6.64346 14.3002C6.64346 18.5452 3.77397 22.0864 0 22.8258V28.5178C3.54127 28.1274 6.28878 26.5173 8.89546 23.4602V28.15H17.6782V23.4207H13.6246V4.72918H17.6782Z"
                />
            </g>
        </svg>
    </div>

    <!-- Motion 3 -->
    <div class="motion-3">
        <svg fill="none" preserveAspectRatio="none" viewBox="0 0 14 10">
            <g>
                <path class="motion-path-3" d="M0 9.68356H3.15285L6.30561 0H0.450381L0 9.68356Z" />
                <path class="motion-path-3" d="M7.43161 0L6.98123 9.68356H10.134L13.2868 0H7.43161Z" />
            </g>
        </svg>
    </div>
</div>

<style>
    /* CSS Variables - 디자인 시스템과 동일 */
    :root {
        --loader-primary-300: rgba(120, 223, 179, 1);
        --loader-secondary-900: rgba(17, 25, 40, 1);
        --loader-white: rgba(255, 255, 255, 1);
    }

    /* Color animations */
    @keyframes motionColor1 {
        0%,
        0.5% {
            fill: var(--loader-white);
        }
        8% {
            fill: var(--loader-primary-300);
        }
        16% {
            fill: var(--loader-secondary-900);
        }
        50% {
            fill: var(--loader-secondary-900);
        }
        96% {
            fill: var(--loader-secondary-900);
        }
        100% {
            fill: var(--loader-white);
        }
    }

    @keyframes motionColor2 {
        0%,
        5% {
            fill: var(--loader-white);
        }
        13% {
            fill: var(--loader-primary-300);
        }
        21% {
            fill: var(--loader-secondary-900);
        }
        52% {
            fill: var(--loader-secondary-900);
        }
        96.5% {
            fill: var(--loader-secondary-900);
        }
        100% {
            fill: var(--loader-white);
        }
    }

    @keyframes motionColor3 {
        0%,
        10% {
            fill: var(--loader-white);
        }
        18% {
            fill: var(--loader-primary-300);
        }
        26% {
            fill: var(--loader-secondary-900);
        }
        28% {
            fill: var(--loader-primary-300);
        }
        32% {
            fill: var(--loader-secondary-900);
        }
        36% {
            fill: var(--loader-primary-300);
        }
        40% {
            fill: var(--loader-secondary-900);
        }
        54% {
            fill: var(--loader-secondary-900);
        }
        97% {
            fill: var(--loader-secondary-900);
        }
        100% {
            fill: var(--loader-white);
        }
    }

    /* Motion container */
    .motion-container {
        position: relative;
        width: 44px;
        height: 44px;
    }

    /* Motion elements */
    .motion-1,
    .motion-2,
    .motion-3 {
        position: absolute;
    }

    .motion-1 {
        width: 23.6%;
        height: 54.7%;
        left: 1.9%;
        top: 27.4%;
    }

    .motion-2 {
        width: 34%;
        height: 54.8%;
        left: 31.2%;
        top: 27.2%;
    }

    .motion-3 {
        width: 25.6%;
        height: 18.6%;
        left: 72.5%;
        top: 13.5%;
    }

    .motion-1 svg,
    .motion-2 svg,
    .motion-3 svg {
        display: block;
        width: 100%;
        height: 100%;
    }

    .motion-path-1 {
        will-change: fill;
        animation: motionColor1 1.07s ease-in-out infinite;
    }

    .motion-path-2 {
        will-change: fill;
        animation: motionColor2 1.07s ease-in-out infinite;
    }

    .motion-path-3 {
        will-change: fill;
        animation: motionColor3 1.07s ease-in-out infinite;
    }
</style>
